import { useLocation, Navigate } from "react-router-dom";
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography } from '@mui/material';
// components
import Page from '../../../components/Page';
import GenerateInstallationReportDetails from "../../../components/SidebarMenuComponents/OAComponent/GenerateInstallationReportDetails";
import StickyHeader from "../../../components/Common/StickyHeader";

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
export default function GenerateInstallationReportDetailsPage() {
    const location = useLocation();
    const {reports} = location.state;

    return (
        <Page title="  Generate Installation Report Details| tiketic" >
          
            <StickyHeader title="Generate Installation Report Details" />

            <ContentStyle>
                <GenerateInstallationReportDetails reports={reports} />
            </ContentStyle>
        </Page>
    );
}

